import { BOTONES } from '../../../../../componentes/botones';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HelpItem, MetricaHelpComponent } from '../metrica-help.component';
import { CardHeaderComponent } from '../../../../../componentes/card-header/card-header.component';
import { ContentCardComponent } from '../../../../../componentes/content-card/content-card.component';

// Una fila del resumen: label + valor ya formateado. La calcula el dashboard
// (tiene los samples del período); acá sólo se muestra.
export interface FilaResumen {
  label: string;
  valor: string;
  destacado?: boolean;
  ayuda?: string;
}

export interface ResumenPeriodoDialogData {
  filas: FilaResumen[];
  // Rango ya formateado, para que el modal diga a qué período corresponde lo
  // que muestra (se abre desde el header y el filtro queda tapado).
  periodo?: string;
  help: HelpItem[];
}

/**
 * Resumen del período en un modal.
 *
 * Son números, no un gráfico: como card ocupaba media pantalla del dashboard
 * para algo que se mira de a ratos (al terminar una corrida, o al comparar dos
 * rangos). Vive detrás de un botón del header y el dashboard queda para lo que
 * sí es visual.
 */
@Component({
  selector: 'app-resumen-periodo-dialog',
  standalone: true,
  imports: [
    MatCardModule,
    CardHeaderComponent,
    ContentCardComponent,
    BOTONES,
    MatIconModule,
    MatTooltipModule,
    MetricaHelpComponent,
  ],
  templateUrl: './resumen-periodo-dialog.component.html',
  styleUrls: ['./resumen-periodo-dialog.component.scss'],
})
export class ResumenPeriodoDialogComponent {
  readonly dialogRef = inject(MatDialogRef<ResumenPeriodoDialogComponent>);
  readonly data: ResumenPeriodoDialogData = inject(MAT_DIALOG_DATA);

  cerrar(): void {
    this.dialogRef.close();
  }
}
